var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"min-height":"1000px"}},[(false)?_c('FollowLanding'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }